import $ from 'jquery';

const $faqContainer = $(".faqs");
const $tabsList = $faqContainer.find(".faqs__tabs");
const $sections = $faqContainer.find(".faqs__sections");
const $faqQuestions = $faqContainer.find(".faq__question");


function toggleActive($el:any, id:any) {
	$el.toggleClass("active", $el.attr("id") === id || $el.data("questionId") === id);

	if ($el.hasClass("active")) {
		$el.find(".faq__answer").slideDown();
	} else {
		$el.find(".faq__answer").slideUp();
	}
}

function toggleTabs(id:any) {
	$tabsList.find(".tab")
		.removeClass("active")
		.filter("#" + id)
		.addClass("active");
}

function toggleSections(id:any) {
	$sections.find(".section")
		.removeClass("active")
		.filter("#" + id)
		.addClass("active");
}

function initTabs() {
	$tabsList.on("click", ".tab", (e) => {
		e.preventDefault();
		const id = $(e.currentTarget).attr("id");
		toggleTabs(id);
		toggleSections(id);

		const newUrl = window.location.pathname + '#' + id;
		window.history.pushState({ path: newUrl }, '', newUrl);
	
	});

	const currentHash = window.location.hash.substring(1);
	const activeTabId = currentHash && $tabsList.find(".tab#" + currentHash).length > 0 ? currentHash : $tabsList.find(".tab").first().attr("id");
	
	toggleTabs(activeTabId);
	toggleSections(activeTabId);
}

function initAccordions() {

	// Close all accordions
	$faqContainer.find(".faq").removeClass("active");
	$faqContainer.find(".faq__answer").slideUp();

	$faqQuestions.click(function(e) {
		const $question = $(this);
		const $parentFaq = $question.closest(".faq");
		const $answer = $question.next();

		$parentFaq.toggleClass("active");

		if ($parentFaq.hasClass("active")) {
			$answer.slideDown();
		} else {
			$answer.slideUp();
		}
	});
}

initAccordions();

// If faqs has the .tabs--include class, then run initTabs(), otherwise add the active class to ALL sections.
if ($faqContainer.hasClass("tabs--include")) {
	initTabs();
} else {
	$sections.find(".section").addClass("active");
}
